import { PlayerPortalsHeader } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: () => PlayerPortalsHeader,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.Header) =>
    kontentAiDataMapping.player_portals_header(entry),
};
